import styled from "styled-components"
import colors from "@src/utils/colors"

export const ValidationDiv = styled.div`
  color: ${colors.error};
`
